import ActionLayout from "pages/events/components/actions/ActionLayout";
import DelayActionIcon from "assets/svg/event-action-delay.svg";
import { secondToTimeString } from "components/modals/SetDelayModal";

type DelayActionProps = {
    showDeleteConfirm: any;
    action: any;
    editDelayAction: () => void;
    checkEditable: any;
};

const DelayAction = ({
    showDeleteConfirm,
    action,
    editDelayAction,
    checkEditable,
}: DelayActionProps) => {
    const renderDelayContent = () => {
        return (
            <>
                <p className="mt-2 mb-3 default-white-color">Delay</p>
                <span className="delay-event__desc">
                    {secondToTimeString(action.resource?.seconds)}
                </span>
            </>
        );
    };

    const renderActionIcon = () => {
        return <img src={DelayActionIcon} alt="action-delay-icon" />;
    };

    return (
        <ActionLayout
            showDeleteConfirm={showDeleteConfirm}
            editAction={(e) => {
                const isEditable = checkEditable(e);
                if (isEditable) {
                    editDelayAction();
                }
            }}
            renderActionIcon={renderActionIcon}
        >
            {renderDelayContent()}
        </ActionLayout>
    );
};

export default DelayAction;
